import React from "react";
import { localize } from "src/l10n";
import { SpintrUser, UnstyledButton } from "src/ui";
import { capitalizeFirstLetter } from "src/utils";
import Visage2Icon from "src/visage2/Visage2Icon/Visage2Icon";
import { IShareTarget } from "./ShareModal.types";
import { shareTargetConfig } from "./shareTargetConfig";

interface IProps {
    target: IShareTarget;
    onSelect: (target: IShareTarget) => void;
    isSelected?: boolean;
}

const ShareTargetItem = (props: IProps) => {
    const { target } = props;
    const config = shareTargetConfig[target.type];

    const description = localize(config.descriptionKey);

    const subText = capitalizeFirstLetter(target.disabled
        ? localize(target.disabledReasonKey || "SHARE_DISABLED_GROUP_NO_CHAT")
        : target.type === "user" && target.info
            ? target.info + " · " + description
            : description);

    return (
        <UnstyledButton
            className={"ShareTargetItem"
                + (target.disabled ? " disabled" : "")
                + (props.isSelected ? " selected" : "")
                + (target.type === "feed" ? " ShareTargetItem--feed" : "")}
            disabled={target.disabled}
            ariaPressed={!!props.isSelected}
            title={target.disabled ? subText : target.name}
            onClick={() => {
                if (target.disabled) {
                    return;
                }

                props.onSelect(target);
            }}
        >
            <SpintrUser
                name={target.name}
                subText={subText}
                imageUrl={target.imageUrl}
                iconToDisplayInsteadOfInitials={!target.imageUrl ? config.iconName : undefined}
                personalName={target.type === "user"}
            />
            {props.isSelected && (
                <Visage2Icon className="ShareTargetItem-selected-icon" icon="tick-circle" type="bold" color="light-blue" size="small" />
            )}
        </UnstyledButton>
    );
};

export default ShareTargetItem;
